import { Box, Card, Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { ArrowUpRight, type LucideIcon } from 'lucide-react'
import { colors } from '@/theme'

/** Industry tile — icon + name, links to the industry page. */
export function IndustryCard({ icon: Icon, name, to }: { icon: LucideIcon; name: string; to: string }) {
  return (
    <Card
      component={RouterLink}
      to={to}
      sx={{
        p: { xs: 2.5, md: 3 },
        height: '100%',
        textDecoration: 'none',
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
        '&:hover': { borderColor: 'primary.main' },
        '&:hover .ind-arrow': { opacity: 1, transform: 'translate(2px, -2px)' },
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Box sx={{ color: 'primary.main' }}>
          <Icon size={28} />
        </Box>
        <ArrowUpRight
          size={18}
          color={colors.grey}
          className="ind-arrow"
          style={{ opacity: 0, transition: 'opacity 300ms ease, transform 300ms ease' }}
        />
      </Stack>
      <Typography variant="h5" component="h3">
        {name}
      </Typography>
    </Card>
  )
}
